import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

// reactstrap components
import { Row, Col, Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";

// views
import Documentos from "../../../views/Shared/Documentos";
import Declaracao from "../../../views/Shared/Declaracao";

//Context
import { useAuth } from '../../../context/auth';
import CardRejeicaoRequerimento from '../components/CardRejeicaoRequerimento';

/**
 * Requerimento de Solicitação de Certidão de Destinação Final (Gerador RSS).
 * Não possui formulário: o fluxo é apenas Documentação -> Declaração.
 */
export default function GeradorRSSRequerimentoSolicitacaoCertidao({ history }) {
    const { session, setLoading, setupSistema } = useAuth();
    const [requerimento, set_requerimento] = React.useState(null);
    const location = useLocation();

    const steps = ['Documentação', 'Declaração'];
    const [step, set_step] = React.useState(0);

    const [opcao, set_opcao] = React.useState(Object);

    const handleProximoStep = (_requerimento) => {
        if (step == 2) {
            history.push("opcoes");
        }
        else {
            set_requerimento(_requerimento);
            set_step(step + 1);
        }
    }

    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento);
        set_step(step - 1);
    }

    const loadRequerimento = () => {
        if (location.state.requerimento == null) {
            setLoading(true);
            let json_submit = {
                protocolo_Id: location.state.protocolo.protocolo_Id,
                requerimento_Id: 0,
                nomeSolicitante: location.state.protocolo.nomeSolicitante,
                email: location.state.protocolo.email,
                cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
            }

            api_POST('requerimento/PostRequerimento ', json_submit)
                .then(result => {
                    set_opcao({
                        tipoCadastro: "Requerimento",
                        segmento: "Grande Gerador",
                        categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                    });
                    set_requerimento(result.data);
                    set_step(0);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            setLoading(true);
            api_GET('requerimento/' + location.state.requerimento.requerimento_Id)
                .then(result => {
                    set_opcao({
                        tipoCadastro: "Requerimento",
                        segmento: "Grande Gerador",
                        categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                    });
                    set_requerimento(result.data);
                    set_step(0);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        loadRequerimento();
    }, []);

    return (
        <>
            {requerimento != null && step < 2 &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    <CardRejeicaoRequerimento requerimento={requerimento} setupSistema={setupSistema} />

                    {step == 0 && <Documentos item={requerimento} opcao={opcao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Documentos>}
                    {step == 1 && <Declaracao item={requerimento} handleFinalizarCadastro={handleProximoStep} handleStepAnterior={handleStepAnterior}></Declaracao>}
                </div>
            }

            {requerimento != null && step == 2 &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    );
}
